import { cva } from '@/styled-system/css';

export const toggleButtonGroupRecipe = cva({
  base: {
    'display': 'flex',
    'position': 'relative',
    'zIndex': 1,

    '& > :where(a, button)': {
      'position': 'relative',
      'zIndex': 1,
      '&[aria-pressed="true"]': {
        zIndex: 2,
      },
      '&:focus': {
        zIndex: 3,
      },
    },
  },

  variants: {
    conjoined: {
      true: {
        '& > :where(a, button)': {
          '&:not(:first-child)': {
            marginInlineStart: 'ButtonGroup.conjoined.gap.offsetBorder',
          },
          '&:not(:first-child):not(:last-child)': {
            borderRadius: 'ButtonGroup.conjoined',
          },
          '&:first-child': {
            borderTopRightRadius: 'ButtonGroup.conjoined',
            borderBottomRightRadius: 'ButtonGroup.conjoined',
          },
          '&:last-child': {
            borderTopLeftRadius: 'ButtonGroup.conjoined',
            borderBottomLeftRadius: 'ButtonGroup.conjoined',
          },
        },
      },
      false: {
        gap: 'ButtonGroup.gap.horz',
      },
    },
  },
});
